module.exports = __webpack_public_path__ + "img/bg-onboarding-second.ff08198e.svg";